export default "__VITE_ASSET__DhqY977V__"